import React from 'react';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import { getRadioOptions } from 'src/reducers/selectOptions';
import selector, { getOptionLabel, display } from 'src/utils/Utils';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { useTranslation } from 'react-i18next';

const TaxClassificationSectionShow = props => {
  const {
    employeeTaxClassification,
    taxScheduleClassifications,
    widowClassifications,
    disabledPersonClassifications,
    graduateStudentClassifications,
    disasterClassifications,
    foreignerClassifications
  } = props;
  
  const { t, i18n } = useTranslation();
  return (
    <div>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th>{t('features.Employees.components.TaxClassInformation.tax_schedule_classification')}：</th>
            <td>
              {display(getOptionLabel(employeeTaxClassification.taxScheduleClassification)(taxScheduleClassifications))}
            </td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.TaxClassInformation.widow_classification')}：</th>
            <td>{display(getOptionLabel(employeeTaxClassification.widowClassification)(widowClassifications))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.TaxClassInformation.disabled_person_classification')}：</th>
            <td>
              {display(
                getOptionLabel(employeeTaxClassification.disabledPersonClassification)(disabledPersonClassifications)
              )}
            </td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.TaxClassInformation.graduate_student_classification')}：</th>
            <td>
              {display(
                getOptionLabel(employeeTaxClassification.graduateStudentClassification)(graduateStudentClassifications)
              )}
            </td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.TaxClassInformation.disaster_classification')}：</th>
            <td>
              {display(getOptionLabel(employeeTaxClassification.disasterClassification)(disasterClassifications))}
            </td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.TaxClassInformation.foreigner_classification')}：</th>
            <td>
              {display(getOptionLabel(employeeTaxClassification.foreignerClassification)(foreignerClassifications))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default connect(state => ({
  employeeTaxClassification: selector(getItem(REDUCER_NAME, state), 'employeeTaxClassification') || {},
  taxScheduleClassifications: getRadioOptions(state, 'taxScheduleClassifications'),
  widowClassifications: getRadioOptions(state, 'widowClassifications'),
  disabledPersonClassifications: getRadioOptions(state, 'disabledPersonClassifications'),
  graduateStudentClassifications: getRadioOptions(state, 'graduateStudentClassifications'),
  disasterClassifications: getRadioOptions(state, 'disasterClassifications'),
  foreignerClassifications: getRadioOptions(state, 'foreignerClassifications')
}))(TaxClassificationSectionShow);
